// extracted by mini-css-extract-plugin
module.exports = {"container":"ShareAsideNew_container__cF0Ir","socialButton":"ShareAsideNew_socialButton__Z16_I"};